import { Button } from "@/components/ui/button";
import { TrendingUp, ShieldCheck, PieChart, Landmark } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const features = [
    { icon: Landmark, t: "Fund & Loan Arrangement" },
    { icon: PieChart, t: "Department Profitability" },
    { icon: TrendingUp, t: "Budgeting & Forecasting" },
    { icon: ShieldCheck, t: "Taxation Compliance" },
  ];

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0F172A]">
      <div className="hidden lg:flex flex-col justify-between p-14 bg-[#0B1120] border-r border-[#334155] relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{ backgroundImage: "radial-gradient(#C9A24B 1px, transparent 1px)", backgroundSize: "28px 28px" }}
        />
        <div className="relative">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-lg bg-[#C9A24B] flex items-center justify-center text-[#0B1120] font-heading font-extrabold text-xl">Y</div>
            <div>
              <div className="font-heading font-bold text-lg tracking-tight">Youngness Finance</div>
              <div className="label-caps">by Dr. Awish</div>
            </div>
          </div>
        </div>
        <div className="relative space-y-8">
          <h1 className="font-heading text-4xl xl:text-5xl font-semibold tracking-tight leading-tight">
            One command centre for<br /><span className="text-[#C9A24B]">financial strength.</span>
          </h1>
          <p className="text-slate-400 text-base max-w-md leading-relaxed">
            Fund arrangement, balance-sheet monitoring, service-wise profitability, budgeting discipline, taxation compliance and government schemes — with an embedded AI intelligence engine.
          </p>
          <div className="grid grid-cols-2 gap-4 max-w-md">
            {features.map((f) => (
              <div key={f.t} className="flex items-center gap-3 rounded-lg border border-[#334155] bg-[#0F172A] px-4 py-3">
                <f.icon className="h-5 w-5 text-[#C9A24B]" />
                <span className="text-sm text-slate-300">{f.t}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="relative label-caps">Finance Department CRM · Youngness Group</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm space-y-8 animate-fade-up">
          <div className="lg:hidden flex items-center gap-3 justify-center">
            <div className="h-10 w-10 rounded-lg bg-[#C9A24B] flex items-center justify-center text-[#0B1120] font-heading font-extrabold">Y</div>
            <div className="font-heading font-bold text-lg">Youngness Finance</div>
          </div>
          <div className="space-y-2 text-center">
            <h2 className="font-heading text-2xl font-semibold">Welcome back</h2>
            <p className="text-slate-400 text-sm">Sign in with your Google account to access the Finance CRM.</p>
          </div>
          <Button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="w-full h-12 bg-[#C9A24B] hover:bg-[#D4AF37] text-[#0B1120] font-semibold rounded-md transition-all active:scale-95"
          >
            <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24">
              <path fill="#0B1120" d="M12 11v2.8h4c-.2 1-1.3 3-4 3-2.4 0-4.4-2-4.4-4.4S9.6 8 12 8c1.4 0 2.3.6 2.8 1.1l1.9-1.9C15.5 6.1 13.9 5.4 12 5.4 8.3 5.4 5.3 8.4 5.3 12s3 6.6 6.7 6.6c3.9 0 6.4-2.7 6.4-6.5 0-.4 0-.8-.1-1.1H12z" />
            </svg>
            Continue with Google
          </Button>
          <p className="text-xs text-slate-500 text-center leading-relaxed">
            Restricted to authorised Youngness Group Finance team members. All activity is logged.
          </p>
        </div>
      </div>
    </div>
  );
}
